import React, { PureComponent } from "react";

import { IBasicControlDefinition, IControlProps, IBasicControlPublicProps } from "./types";

export const ControlChangeDelay = 500;

export default function forBasicControl<TValue, TConfig extends IBasicControlDefinition>(Control: React.ComponentType<IControlProps<TValue, TConfig>>) {

    interface IState {
        value: any;
        isDirty: boolean;
        renewValidation: number;
    }
    class BaseControl extends PureComponent<IBasicControlPublicProps<TValue, TConfig>, IState> {
        constructor(props: IBasicControlPublicProps<TValue, TConfig>) {
            super(props);
            this.state = {
                isDirty: false,
                renewValidation: 0,
                value: props.value,
            };
        }

        public componentDidUpdate(prev: IBasicControlPublicProps<TValue, TConfig>) {
            if (prev.value !== this.props.value && this.props.value !== this.state.value) {
                //special case for NaN (because NaN !== NaN return true)
                if (typeof(this.props.value) === 'number' && typeof(this.state.value) === 'number' && isNaN(this.props.value) && isNaN(this.state.value))
                    return;

                this.setState({ value: this.props.value, isDirty: false });
            }
        }

        private onChange(value: any) {
            this.setState({
                value, isDirty: true
            });

            this.props.onChange(value);
        }
        private onBlur() {
            if (this.state.isDirty) {
                this.setState({
                    renewValidation: this.state.renewValidation + 1, 
                });
            }
        }
        public render() {
            const renewValidation = this.props.renewValidation + this.state.renewValidation;

            return <Control
                context={this.props.context}
                showValidation={renewValidation > 0}
                onChange={(value, blur) => this.onChange(value)}
                onBlur={() => this.onBlur()}
                readOnly={this.props.readOnly}
                value={this.state.value}
                definition={this.props.definition}
                isValid={!this.props.validation}
                validationMessage={this.props.validation && this.props.validation.message}
            />
        }
    }
    return BaseControl;
};
